import FaveBizAPI from 'integrations/FaveBizAPI';
import { GenericSuccessType } from '../types/GenericSuccessType';

export const updateFeedPost = (
  id: number | undefined,
  param: FormData
): Promise<GenericSuccessType> =>
  FaveBizAPI.multipartRequest(`/v1/feed/${id}`, param, { method: 'PUT' });
